import * as THREE from 'three';
import { gsap } from 'gsap';

import Project from "../Project.js";
import Enviorment from './Enviorment.js';
import Floor from './Floor.js';
import Asset3D from './Asset3D.js';
import RayCaster from './RayCaster.js';

export default class World {
	constructor() {
		console.log( "World File" );
		this.project = new Project(); // create ref to the project class 
		this.zappar = this.project.zappar; // create ref to Zappar in the project file
		this.scene = this.project.scene; // create ref to the scene in the project file
		
	}
	init() {
		// Setup
		this.enviorment = new Enviorment(); // initialise the enviorment and create a ref
		this.plane = new Floor( 5 ); // Create a shadow plane
		//this.asset3D = new Asset3D(); // initialise the asset3D and create a ref
		this.asset3D = new Asset3D(); // initialise the asset3D and create a ref
		this.raycaster = new RayCaster();

		this.setInstance();
		this.placement_Indicator_initialise();
		//this.asset3D.createTrees();
		//this.asset3D.treeGrow();
		this.editText("Plant one of the sprouts to see what it grows into!");

	}
	
	setInstance() {
		// Call the corresponding setInstance function
		this.asset3D.setInstance();
	}
	// Create a circle placed below
	placement_Indicator_initialise() {
		// Create a new Mesh of CircleGeometry and a new MeshBasicMaterial to be applied to the mesh
		this.placement_indicator_mesh = new THREE.Mesh(
			new THREE.CircleGeometry( 0.4, 32 ),
			new THREE.MeshBasicMaterial( { color : new THREE.Color( "#00491F" ), } ),
		);
		// Needs to be added to the zappar tracking group to be visiable in the scene
		this.zappar.instantTrackerGroup.add( this.placement_indicator_mesh );
		// Set the scale and rotation 
		this.placement_indicator_mesh.scale.set( 0, 0, 1 );
		this.placement_indicator_mesh.position.y = 0.01;
		this.placement_indicator_mesh.rotation.x = - Math.PI / 2;
	}

	returnedIntersectedObject( intersectedMesh){
		let textContent;
		if(intersectedMesh.name === "PineTree1")
		{
			this.project.changeMode = false;
			this.project.CanSelect = false;
			this.asset3D.treeGrowManager(1);
		}
		else if(intersectedMesh.name === "Lavender1")
		{
			this.project.changeMode = false;
			this.project.CanSelect = false;

			this.asset3D.lavenderGrow(1);
		}
		else if(intersectedMesh.name === "Cosmos1")
		{
			this.project.changeMode = false;
			this.project.CanSelect = false;
			this.asset3D.CosmosGrow(1);
		}
		if(textContent != null) {
		this.editText(textContent);
		textContent = null;
		console.log(intersectedMesh);
		clearInterval( this.interval);
		this.interval = setInterval( () =>
		{
			clearInterval(this.interval);
		}, 2000)
	}
	
	}
	editText(textContent){

		document.getElementById("infor-text").innerText = textContent;
		document.getElementById("infor-textBox").style.display = "flex";}

	/*ButtonSelector(ID){
		//for (let i = 0; i < this.asset3D.sceneModels.length; i++)
		//{
		//	this.asset3D.sceneModels[i].visible = false;
		//	this.asset3D.sceneModels[i].position.set = (1000,0,0);
		//}
		
		switch(ID){
			case 1:
			this.asset3D.model.getObjectByName("PineTree1").visible = true;
			this.asset3D.model.getObjectByName("PineTree1").position.x = (0);
			console.log(this.scene.getObjectByName("PineTree1"))
			break;

			case 2:
			
			this.asset3D.model.getObjectByName("Lavender1").visible = true;
			this.asset3D.model.getObjectByName("Lavender1").position.set = (0,0,0);
			console.log(this.asset3D.model.getObjectByName("Lavender1").position);

			break;

			case 3:
			
			this.asset3D.model.getObjectByName("Cosmos1").visible = true;
			this.asset3D.model.getObjectByName("Cosmos1").position.set = (0,0,0);
			
			break;


		}
	}*/
	// This Function is called for the project script. 
	placementMode( bool ) {
		if ( bool ) {
			this.project.hasPlaced = false;
			this.editText("Try using the watering can on the sprout to help it grow!");
			this.asset3D.placementMode( true );
			// Animate the x and y scale of the placement_indicator_mesh, the default scale in 0 so GSAP will animate x and y value from 0 to 1 over the set duration, in this case 0.4 seconds
			gsap.to( this.placement_indicator_mesh.scale, { x : 1, y : 1, duration : 0.4 } );
			this.placement_indicator_mesh.visible = true;
		}
		else if ( !bool ) {
			if ( this.project.initalPlacement ) {
				// Stuff to happen on the first time placement
				this.project.initalPlacement = false;
			}
			// Animate the X and Y scale from the current value (in this case 1, this is the value set above) to 0 over a duration of 0.4 seconds
			

			gsap.to( this.placement_indicator_mesh.scale, {
				x : 0,
				y : 0,
				duration : 0.4,
				// a call back is used to then wait for the animaton to finsihed before complete the below actions
				onComplete : () => {
					this.placement_indicator_mesh.visible = false;
					this.project.hasPlaced = true;
					this.asset3D.placementMode( false );
					
				}
				
			} );
		}
	}
	update() {
		if ( this.project.hasPlaced ) { // If not in placement mode
			// this is only called if not in placement mode, this prevents animations playing while the user is trying to place the Instant Tracking Group
			if ( this.asset3D ) {
				this.asset3D.update();
			}
		}
		// Only update the enviorment class if the camera exsits 
		if ( this.project.camera ) {
			this.enviorment.update();
		}
	}
}

